import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface ITransactionIdFilterSelectProps {
    value: (number | string)[];
    onChange: (value: (number | string)[]) => void;
    options: ISelectOption<number | string>[];
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    isLoading?: boolean;
}

export const TransactionIdFilterSelect: React.FC<ITransactionIdFilterSelectProps> = ({
    value,
    onChange,
    label,
    height = 300,
    disabled = false,
    options,
    searchable = true,
    isLoading,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            resizable
            loading={isLoading}
            searchable={searchable}
            showSelectAllOption={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
